import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import XtractLogger from './Auth/XtractLogger.jsx'
import withLocation from 'HigherOrder/withLocation.jsx'
import { startClock, stopClock } from 'actions/clockActions'
import { compose } from 'redux'
import moment from 'moment-timezone'
import ModalFramework from 'GeneralUI/ModalFramework/ModalFramework.jsx'
import AppRouter from './AppRouter.jsx'
import withLoginToLastLocation from './HigherOrder/withLoginToLastLocation.jsx'
import UrgentNotificationBanner from 'GeneralUI/UrgentNotificationBanner/UrgentNotificationBanner.jsx'

export const startingZIndex = 100000

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(startClock())
    dispatch({ type: 'start-tooltip-manager' })

    return () => {
      dispatch(stopClock())
      dispatch({ type: 'stop-tooltip-manager' })
    }
  }, [])

  return (
    <div className="main-wrapper">
      <XtractLogger />
      <ModalFramework
        coverOpacity={0.5}
        startingZIndex={startingZIndex}
      />
      <div className="main-panel">
        <UrgentNotificationBanner/>
        <AppRouter />
      </div>
    </div>
  )
}

const enhance = compose(
  withLocation(),
  withLoginToLastLocation()
)

export default enhance(App)
